import styled from "styled-components";
import { Link as LinkR } from "react-router-dom";
import { Link as LinkS } from "react-scroll";

export const Nav = styled.nav`
  background-color: ${({ scrollNav }) =>
    scrollNav ? "#0E1A24" : "transparent"};
  padding: 1rem 1rem 1rem 1rem;
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1rem;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;
  transition: background-color 0.8s ease, box-shadow 0.4s ease;

  box-shadow: ${({ scrollNav }) =>
    scrollNav ? "0 12px 30px rgba(0,0,0,0.32)" : "none"};

  @media screen and (max-width: 960px) {
    transition: 0.8s all ease;
  }

  /* Edge-to-edge on short landscape screens */
  @media (orientation: landscape) and (max-height: 450px) {
    padding: 0;
  }
`;

export const NavbarContainer = styled.div`
  display: flex;
  justify-content: space-between;
  height: 80px;
  z-index: 1;
  width: 100%;
  padding: 0 24px;
  max-width: 1600px;

  /* Edge-to-edge on mobile and short landscape */
  @media screen and (max-width: 768px) {
    padding: 0;
    max-width: 100vw;
  }

  @media (orientation: landscape) and (max-height: 450px) {
    padding: 0;
    max-width: 100vw;
  }
`;

export const NavLogo = styled(LinkR)`
  justify-self: flex-start;
  cursor: pointer;
  text-decoration: none;
  align-items: center;
  display: flex;
  margin-left: 24px;
  width: 10rem;
  min-width: 10rem;
  flex: 0 0 auto;
`;

export const Logo = styled.img`
  width: 100%;
  margin: 0 0 0 0;
  padding-right: 0;
`;

export const MobileIcon = styled.div`
  display: none;
  /* Show mobile icon on narrow width OR short height (landscape phones) */
  @media screen and (max-width: 768px), screen and (max-height: 450px) {
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(-100%, 60%);
    font-size: 1.8rem;
    cursor: pointer;
    color: #fff;
  }
`;

export const NavMenu = styled.ul`
  display: flex;
  align-items: center;
  list-style: none;
  text-align: center;
  margin-right: -22px;
  /* Hide full nav on narrow width OR short height (landscape phones) */
  @media screen and (max-width: 768px), screen and (max-height: 450px) {
    display: none;
  }
`;

export const NavItem = styled.li`
  height: 80px;
`;

export const NavLinks = styled(LinkS)`
  color: #fff;
  display: flex;
  align-items: center;
  text-decoration: none;
  padding: 0px 1rem 0 1rem;
  height: 100%;
  cursor: pointer;
`;

export const BtnWrap = styled.div`
  display: flex;
  justify-content: center;
  padding: 0px 1rem 0 1rem;
`;

export const NavButton = styled.a`
  border-radius: 50px;
  background: ${({ primary }) => (primary ? "#ffcb66" : "#010606")};
  white-space: nowrap;
  padding: ${({ big }) => (big ? "14px 48px" : "12px 30px")};
  color: ${({ dark }) => (dark ? "#010606" : "#fff")};
  font-size: ${({ fontBig }) => (fontBig ? "20px" : "16px")};
  outline: none;
  border: none;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.2s ease-in-out;
  text-decoration: none;

  &:hover {
    transition: all 0.2s ease-in-out;
    background: ${({ primary }) => (primary ? "#FFF" : "#ffcb66")};
    color: #000;
  }
`;
